
import { defineComponent} from 'vue'


export default defineComponent({
    name: 'NotificationDialog',
    data() {
        return {
            loading: false,
            dialog: false,
            dialogType: '',
            dialogMessage: '',
            dialogTitle: '',
            hasCallback: false,
        };
    },
    methods: {
        async onYesClicked() {
            this.loading = true;
            try {
                await this.callback(this.$data);
                this.dialog = false;
            } finally {
                this.loading = false;
            }
        },
        async callback(data: any) {},
    },
    computed: {
        htmlDialogMessage(): string {
            if (!this.dialogMessage || typeof this.dialogMessage !== 'string') {
                return '';
            }
            return this.dialogMessage.replaceAll('\n', '<br>');
        },
    },
    created() {
        this.$store.subscribe((mutation, state) => {
            if (mutation.type === 'notificationDialog/showMessage') {
                this.dialogType = state.notificationDialog.dialogType;
                this.dialogMessage = state.notificationDialog.dialogMessage;
                this.dialogTitle = state.notificationDialog.dialogTitle;
                this.loading = state.notificationDialog.loading;
                this.dialog = state.notificationDialog.dialog;
                if (state.notificationDialog.onYesClicked) {
                    this.hasCallback = true;
                    this.callback = state.notificationDialog.onYesClicked;
                } else {
                    this.hasCallback = false;
                }
            }
        });
    },
});
